//Leads
export const GET_LEADS = 'GET_LEADS';
export const LOADER_ACTIVATE = 'LOADER_ACTIVATE';
export const POST_LEADS_MSG = 'POST_LEADS_MSG';
export const POST_NEW_LEADS_MSG = 'POST_NEW_LEADS_MSG';
export const GET_LEAD_BY_PHONE = 'GET_LEAD_BY_PHONE';
export const CLEAR_PHONE_REDUCER = 'CLEAR_PHONE_REDUCER';

//Toast
export const GET_TOAST = 'GET_TOAST';

//Inbox
export const GET_INBOX_MSG = 'GET_INBOX_MSG';
export const GET_ALL_LEAD_MSG = 'GET_ALL_LEAD_MSG';
export const BACKDROP_STATUS = 'BACKDROP_STATUS';
export const ADD_LEAD_LOADER = 'ADD_LEAD_LOADER';
export const FILTER_STATE = 'FILTER_STATE';

//GlobalSearch
export const GET_SEARCHED_DATA = 'GET_SEARCHED_DATA';

//Admin
export const GET_AVAILABLE_NUMBER = 'GET_AVAILABLE_NUMBER';

// Apartment
export const GET_ALL_BUILDING = 'GET_ALL_BUILDING';
export const GET_BUILDING_BY_ID = 'GET_BUILDING_BY_ID';
export const GET_TOUR_TYPES_BY_APARTMENT = 'GET_TOUR_TYPES_BY_APARTMENT';
